export enum GameplayEvents {
  DRAGON_ROAR = 'dragon_roar',
  DRAGON_GRUNT = 'dragon_grunt',
  DAMAGE_DRAGON = 'damage_dragon',
  POISON_DAMAGE_DRAGON = 'poison_damage_dragon',
  POISON_ATTACK_DRAGON = 'poison_attack_dragon',
  LIGHTNING_DAMAGE_DRAGON = 'lightning_damage_dragon',
  POPE_HEAL_DRAGON = 'pope_heal_dragon',
  PURCHASED_UPGRADE = 'purchased_upgrade',
  MET_DRAGON = 'met_dragon',
  CLICK_GAME_DRAGON = 'click_game_dragon',
  SHOOT_CATAPULT = 'shoot_catapult',
  STOP_CLICK_GAME_DRAGON = 'stop_click_game_dragon',
  CLICK_GAME_FARM = 'click_game_farm',
  CLICK_GAME_BIRD = 'click_game_bird',
  CREATE_GAME_BIRD = 'create_game_bird',
  WAIT_FOR_LAST_HIT = 'wait_for_last_hit',
  STUN_UNITS = 'stun_units',
  UNSTUN_UNITS = 'unstun_units',
  CRITICAL_HIT = 'critical_hit',
}

export enum DungeonEvents {
  OPEN_CHEST = 'open_chest',
  OPEN_DOOR = 'open_door',
  OPEN_EXIT_DOOR = 'open_exit_door',
  DOOR_LOCKED = 'door_locked',
  ATTACK_ENEMY = 'attack_enemy',
  START_BATTLE = 'start_battle',
  ENTER_DUNGEON = 'enter_dungeon',
  EXIT_DUNGEON = 'exit_dungeon',
  FOOTSTEP = 'footstep',
  PICK_ITEM = 'pick_item',
}
